import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { DeleteDocumentCategoryActions } from 'store/ducks/settings/document-category';

export function* deleteDocumentCategoryRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/document-category/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteDocumentCategoryActions.success(data));
    notify('success', 'Categoria de documento deletado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(DeleteDocumentCategoryActions.failure(errorMessage));
  }
}
